import { UNLIMITED_PAGE_SIZE } from "@/common/api/_defaults";
import { useBranchSearchQuery } from "@/common/api/branch/use-branch-search.query";
import { AttributeAppRolePrefix, extractAttributeAppRolesByPrefix } from "@/common/helpers/user-attribute-app-roles";
import { userStore } from "@/store/user-store";
import { useMemo } from "react";

export function useUserAssignedBranches() {
  const { user } = userStore();

  const userBranchesTechnicalIds = extractAttributeAppRolesByPrefix(user?.roles ?? [], AttributeAppRolePrefix.Branch);

  const { data: branchesData, isLoading: branchesAreLoading } = useBranchSearchQuery({
    options: {
      body: {
        technicalId: userBranchesTechnicalIds,
      },
      parameters: {
        pageSize: UNLIMITED_PAGE_SIZE,
      },
    },
    enabled: userBranchesTechnicalIds.length > 0,
  });

  const userBranchUuids = useMemo(() => branchesData?.data?.map((branch) => branch.uuid) ?? [], [branchesData]);

  return { userBranchUuids, userBranchesTechnicalIds, branchesAreLoading };
}
